// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3dbN2","row":"styles_row__DU-GH"};